import { InviteStatusEnum } from './../../../../core/models/enums/InviteStatus';
import { Component, OnInit, Inject, Input, Output } from "@angular/core";
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { Invite } from "src/app/core/models/invite-model";
import { InviteCreation } from "src/app/core/models/inviteCreationModel";
import { IAuthService } from "src/app/core/services/api/contracts/auth-service";
import { InviteService } from "src/app/core/services/api/invite.service";
import { AuthService } from "src/app/core/services/api/auth.service";
import { SystemAccountCreationByInviteModel } from "src/app/core/models/api-models/system-account-creation-by-invite-model";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import {
  BasicModalOperationResult,
  DialogModalComponent,
  IBasicModalComponentInstance,
} from "src/app/shared/components/dialog-modal/dialog-modal.component";
import { RegularExpressionsConstants } from "src/app/shared/constants/regular-expressions";
import { MustMatch } from "src/app/core/helpers/must-match.validator";
import { TranslateService } from "@ngx-translate/core";
import { IWService } from "src/app/core/services/iw.service";

@Component({
  selector: "invitation-registration",
  templateUrl: "./invitation-registration.component.html",
  styleUrls: ["./invitation-registration.component.css"],
})
export class InvitationRegistrationComponent implements OnInit {
  public userAccount = new SystemAccountCreationByInviteModel();
  public invite: InviteCreation;
  public inviteId: number;
  public inviteForm: FormGroup;
  public userNameExist: boolean = false;
  public submitting: boolean = false;
  public showSpinner = true;
  public associatedDID = false;
  public waitAMinute = false;
  constructor(
    private fb: FormBuilder,
    private inviteService: InviteService,
    private accountService: AuthService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private router: Router,
    private patterns: RegularExpressionsConstants,
    public iwService: IWService,
    @Inject("IAuthService") private authService: IAuthService,
    public translate: TranslateService
  ) {
    this.inviteForm = this.fb.group({
      OrganizationCode: new FormControl(""),
      Organization: new FormControl(""),
      UserEmail: new FormControl(""),
      Name: new FormControl(""),
      Role: new FormControl(""),
      SystemAccountIdSintra: new FormControl(""),
    });
  }

  async ngOnInit() {
    const inviteId = this.route.snapshot.paramMap.get("inviteId");
    this.inviteId = +atob(inviteId);
    await this.getInvite(this.inviteId);
    this.setupForm();
    this.showSpinner = false;
  }

  setupForm() {
    this.inviteForm.patchValue({
      OrganizationCode: this.invite.organizationCode,
      Organization: this.invite.organizationName,
      UserEmail: this.invite.email,
      Name: `${this.invite.firstName} ${this.invite.lastName}`,
      Role: this.invite.role,
      SystemAccountIdSintra: this.invite.systemAccountIdSintra
    });
  }

  async getInvite(inviteId) {
      this.invite = await this.inviteService.get(inviteId);
      if(this.invite.status == InviteStatusEnum.InviteRegisteredUser) {
        this.showErrorAlredyRegistered();
      }
      else{
        let existUserByOrganization = await this.inviteService.existUserByOrganization(this.invite.systemAccountIdSintra, this.invite.organizationCode)
        if(existUserByOrganization)  {
          this.showErrorAlredyExistUserByOrganization();
        }
      }
      
      if(this.invite.statusSystemAccountIdSintra == true)
      {
        this.associatedDID = true;
      }
  }

  async onSubmit() {
    this.submitting = true;
    this.showSpinner = true;
    let account = new SystemAccountCreationByInviteModel();
    account.inviteId = this.inviteId;
    account.firstName = this.invite.firstName;
    account.lastName = this.invite.lastName;
    account.email = this.invite.email;
    account.parentOrganizationId = this.invite.parentOrganizationId;
    account.organizationCode = this.invite.organizationCode;
    account.organizationName = this.invite.organizationName;
    account.role = this.invite.role;
    account.associatedOrganizationId = this.invite.associatedOrganizationId;
    account.statusSystemAccountIdSintra = this.invite.statusSystemAccountIdSintra;
    account.systemAccountIdSintra = this.invite.systemAccountIdSintra;

    //TODO: VER COMO MANEJAR EL USUARIO REPETIDO
    try {
      this.waitAMinute = true;
      await this.authService.RegisterWithInvite(account);
      let isAuthenticated = await this.authService.isAuthenticated();
      if (isAuthenticated) {
        await this.showSuccessfulRegisterMessage();
        this.router.navigate(["/"]);
      } 
      this.showSpinner = false;
      this.submitting = false;
      this.waitAMinute = false;
    } catch (error) {
      this.showSpinner = false;
      this.submitting = false;
      this.waitAMinute = false;
    }
  }

  async showSuccessfulRegisterMessage() {
    const modalRef = this.modalService.open(DialogModalComponent, {
      backdrop: "static",
      keyboard: false,
    });

    const modalInstance =
      modalRef.componentInstance as IBasicModalComponentInstance;
    modalInstance.title = this.translate.instant(
      "inviteRegistration.registerSucceededTitle"
    );
    modalInstance.body = this.translate.instant(
      "inviteRegistration.registerSucceededBody"
    );
    modalInstance.type = BasicModalOperationResult.Success;

    await modalRef.result;
  }

  showErrorAlredyRegistered(){
    const modalInstance = this.modalService.open(DialogModalComponent)
    .componentInstance as IBasicModalComponentInstance;
    modalInstance.title = "Error";
    modalInstance.body = this.translate.instant("inviteRegistration.alreadyRegisteredUser");
    modalInstance.type = BasicModalOperationResult.Error;
    modalInstance.buttons = [{
      text: "Ok",
      cssClass: "btn btn-success",
      closeModalOnClick: true,
      handler: async (btn) => {
          this.router.navigateByUrl("/");
      },
  }];
  }

  showErrorAlredyExistUserByOrganization(){
    const modalInstance = this.modalService.open(DialogModalComponent)
    .componentInstance as IBasicModalComponentInstance;
    modalInstance.title = "Error";
    modalInstance.body = this.translate.instant("inviteRegistration.userByOrganizationAlreadyRegistered");
    modalInstance.type = BasicModalOperationResult.Error;
    modalInstance.buttons = [{
      text: "Ok",
      cssClass: "btn btn-success",
      closeModalOnClick: true,
      handler: async (btn) => {
          this.router.navigateByUrl("/");
      },
  }];
  }
}
